import React, { useRef, useState, useEffect } from "react";
import Header from "components/layout/Headers/Header.js";
import { Button, Card, CardBody, Container, Spinner } from "reactstrap";
import Select from "react-select";
import { stylesSelect, DropdownIndicator, ClearIndicator } from "../../../Store/styled/select";
import { Formik, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import {
  getSegmentOptionList,
  getAccountCommonList,
  setAccountOptionList,
  getSymbolList,
  setSymbolList,
  setAgentORSubBrokerList,
}  from "../../../Store/Reducer/common.slice";
import DatePicker from "react-datepicker";
import { getValansList, setValansList } from "../../../Store/Reducer/valan.slice";
import {
  getTradeReport,
  setIsReportGet,
  setTradeReportFilterValue,
} from "../../../Store/Reducer/report.slice";
import { checkIsEmpty } from "utils/common";
import { getAuthoritysList } from "../../../Store/Reducer/adminSlice/admin.slice";
import { getSessionData } from "utils/common";
import { UI_DATEPICKER_FORMAT } from "utils/dateFormats";

const reportOptions = [
  { value: 1, label: "Net Position" },
  { value: 2, label: "Net Position (Break Even)" },
  { value: 3, label: "Net Position (Script Wise)" },
  { value: 4, label: "Position Hudiyu" },
  { value: 5, label: "Position Hudiyu (Summary)" },
];
const userReportOptions = [{ value: 1, label: "Net Position" }];
const userReportBill = [
  { value: 1, label: "Script Wise Bill" },
  { value: 2, label: "Script Wise Bill (T Format)" },
];
const subBrokerReportBill = [
  { value: 1, label: "Script Wise Bill" },
  { value: 5, label: "Script Wise Bill (With Brokerage)" },
];
const reportBill = [
  { value: 1, label: "Script Wise Bill" },
  { value: 2, label: "Script Wise Bill (T Format)" },
  { value: 3, label: "Script Wise Bill (Position and Ledger)" },
  { value: 4, label: "Script Wise Bill (Position and Ledger - T Format)" },
  { value: 5, label: "Script Wise Bill (With Brokerage)" },
  { value: 6, label: "Script Wise Bill (Without Gross Rate)" },
  { value: 7, label: "Summary Bill" },
  { value: 13, label: "Trial Balance With Summary Bill" },
];

const GlobalReport = [
  { value: 1, label: "Global Summary" },
  { value: 2, label: "Subbroker Prospective" },
];
const subBrokerGlobalReport = [{ value: 1, label: "Global Summary" }];

const TradeReport = [
  { value: 1, label: "Trade Book" },
  { value: 2, label: "Trade Hodiyu" },
  { value: 3, label: "Trade Hodiyu (Summary)" },
];

const BrokerateReportOption = [
  { value: 1, label: "Client Wise Brokerage" },
  { value: 2, label: "Client Wise Brokerage (Net)" },
  { value: 3, label: "Sub Broker Brokerage" },
  { value: 4, label: "Subbroker + Child Sb Brokerage" },
];

const RMSReportOption = [
  { value: 1, label: "RMS" },
  { value: 2, label: "RMS (Break Even)" },
];

const orderByOption = [
  { value: 1, label: "Client Code" },
  { value: 2, label: "Client Name" },
];

function ReportTrade({ darkTheme = false }) {
  const ref = useRef(null);
  const dispatch = useDispatch();
  const selectStyles = stylesSelect;
  const { segmentsList, accountOptionList, symbolList } =
    useSelector(({ common }) => common);
  const { userRole } = useSelector(({ auth }) => auth);
 const { userAuthorityList = [] } = useSelector(
  (state) => state.admin || {}
);
  const { valansList } = useSelector(({ valan }) => valan);
  const { isReportGet, tradeReportFilterValue, tradeReportLoading } =
    useSelector(({ report }) => report);
  let finalValanList =
    userRole === "User"
      ? valansList?.length > 0 &&
      valansList.slice(0, 2).map((item2) => {
        return { label: item2.name, value: item2.id };
      })
      : valansList &&
      valansList.map((item2) => {
        return { label: item2.name, value: item2.id };
      });
  let localData = getSessionData();
  const initialValues = {
    userId: "",
    reportType: "",
    report: "",
    valan: "",
    symbol: "",
    segment: "",
    dateFilter: "",
    // subBroker: "",
    liveRateSource: "",
    expiryDate: "",
    liverateDate: "",
    isExpiryDate: false,
    orderBy: "",
    accountSettingType: "1",
    valanStartDate: "",
    endDate: "",
  };

  const [reportForTypeOption, setReportForTypeOption] = useState(reportBill);
  const [accountType, setAccountType] = useState("1");
  const [valanSelected, setValanSelected] = useState();
  const [isLiveRateSource, setIsLiveRateSource] = useState(false);
  const [reportMode, setReportMode] = useState("pdf");
  const reportModeRef = useRef("pdf");
  const pdfWindowRef = useRef(null);
  const [isInitialRender, setIsInitialRender] = useState(true);
  const [valanSelectedFirst, setValanSelectedFirst] = useState("");
  const [selectedUser, setSelectedUser] = useState([]);

  useEffect(() => {
    dispatch(setValansList([]));
    dispatch(getValansList());
    dispatch(getSegmentOptionList());
    dispatch(getAccountCommonList({ roleName: "User" }));
    dispatch(getAccountCommonList({ roleName: "Sub Broker" }));
    dispatch(getAuthoritysList());
    if (isReportGet) {
      dispatch(
        setTradeReportFilterValue({
          ...tradeReportFilterValue,
          dateFilter: "All",
          liveRateSource: "2",
          expiryDate: new Date(),
          liverateDate: new Date(),
          accountSettingType: "1",
          orderBy: orderByOption[0],
        })
      );
    } else {
      dispatch(
        setTradeReportFilterValue({
          ...initialValues,
          reportType: "2",
          report: reportForTypeOption[0],
          dateFilter: "All",
          liveRateSource: "2",
          expiryDate: new Date(),
          liverateDate: new Date(),
          valanStartDate: new Date(),
          valanEndDate: new Date(),
          accountSettingType: "1",
          orderBy: orderByOption[0],
        })
      );
    }
    return () => {
      dispatch(setAgentORSubBrokerList([]));
      dispatch(setAccountOptionList([]));
      dispatch(setValansList([]));
      setIsInitialRender(false);
    };
  }, [dispatch]);

  useEffect(() => {
    if (isInitialRender && valansList && valansList.length > 0) {
      let valanObj = {};
      let lastObj = valansList.filter((item) => {
        if (item.status) {
          return item;
        }
      })[0];
      valanObj.label = !checkIsEmpty(lastObj) ? lastObj.name : "";
      valanObj.value = !checkIsEmpty(lastObj) ? lastObj.id : "";
      lastObj && setValanSelectedFirst({...lastObj, startDate: new Date(lastObj.startDate), endDate: new Date(lastObj.endDate)});
      setValanSelected(valanObj);
      // setTradeReportFormInit((prev) => ({
      // 	...prev,
      // 	valan: valanObj,
      // 	valanStartDate: new Date(lastObj.startDate),
      // 	valanEndDate: new Date(lastObj.endDate),
      // }));
      if (tradeReportFilterValue.reportType === "1") {
        setReportForTypeOption(reportOptions);
      } else if (tradeReportFilterValue.reportType === "2") {
        setReportForTypeOption(
          userRole === "User"
            ? userReportBill
            : userRole === "Sub Broker" || userRole === "Partner"
              ? subBrokerReportBill
              : reportBill
        );
      } else if (tradeReportFilterValue.reportType === "3") {
        setReportForTypeOption(GlobalReport);
      } else if (tradeReportFilterValue.reportType === "4") {
        setReportForTypeOption(TradeReport);
      } else if (tradeReportFilterValue.reportType === "5") {
        setReportForTypeOption(BrokerateReportOption);
      } else {
        setReportForTypeOption(RMSReportOption);
      }
      if (!isReportGet) {
        dispatch(
          setTradeReportFilterValue({
            ...tradeReportFilterValue,
            valan: valanObj,
            valanStartDate: new Date(lastObj.startDate),
            valanEndDate: new Date(lastObj.endDate),
          })
        );
      }
      setIsInitialRender(false);
    }
  }, [valansList, isInitialRender]);
  useEffect(() => {
    if (valanSelectedFirst?.id == (valanSelected && valanSelected.value)) {
      setIsLiveRateSource(true);
    } else {
      setIsLiveRateSource(false);
    }
  }, [valanSelected]);

  const handleReportSubmitChange = (e, reportMode) => {
    e.preventDefault();
    setReportMode(reportMode);
    reportModeRef.current = reportMode;
    if (reportMode === "pdf") {
      try {
        // open synchronously from click to avoid popup blockers
        pdfWindowRef.current = window.open("about:blank", "_blank");
      } catch {
        pdfWindowRef.current = null;
      }
    } else {
      pdfWindowRef.current = null;
    }
    ref.current && ref.current.handleSubmit();
  };

  const tradeReportSchema = Yup.object().shape({
    reportType: Yup.string().required("*Report Type require"),
    valan: Yup.object().nullable().required(`*Required field`),
    orderBy: Yup.object().nullable().required("*Order By require"),
  });
  const changeReportForTypeOptionValue = (
    reportTypeValue,
    reportForTypeOptionValue
  ) => {
    dispatch(
      setTradeReportFilterValue({
        ...tradeReportFilterValue,
        reportType: reportTypeValue,
        report: reportForTypeOptionValue[0],
        userId: selectedUser,
        accountSettingType: accountType,
        valan: valanSelected,
      })
    );
    setReportForTypeOption(reportForTypeOptionValue);
    // setIsLiveRateSource(true);
  };
  return (
    <div className={`fx-trade-report${darkTheme ? " fx-trade-report--dark" : ""}`}>
      <Header />
      {/* <Html>{htmldata}</Html> */}
      <Container fluid className="py-4">
        <div className="row g-4 align-items-center">
          <div className="col-12 col-sm-auto">
            <h4 className="mb-0 fx-trade-report__title">Trade Report</h4>
          </div>
          <div className="col-12 col-sm-auto ms-sm-auto">
            <div className="row g-2">
              <div className="col-auto">
                <Button
                  color="default"
                  className="fx-trade-report__btn-view"
                  onClick={(e) => handleReportSubmitChange(e, "pdf")}
                >
                  {tradeReportLoading ? "Loading..." : "View Report"}
                </Button>
              </div>
              <div className="col-auto">
                <Button
                  color="success"
                  className="fx-trade-report__btn-excel"
                  onClick={(e) => handleReportSubmitChange(e, "excel")}
                >
                  Excel Report
                </Button>
              </div>
            </div>
          </div>
        </div>
        <hr className="my-2 fx-trade-report__divider" />
        <div className="row">
          <div className="col-12">
            <Card className="mb-4 fx-trade-report__card">
              <CardBody className="px-lg-3 py-lg-3">
                <Formik
                  enableReinitialize={true}
                  initialValues={tradeReportFilterValue}
                  validationSchema={userRole !== "User" && tradeReportSchema}
                  innerRef={ref}
                  onSubmit={(value) => {
                    const mode = reportModeRef.current || reportMode;
                    if (userRole === "User") {
                      const values = {
                        ...value,
                        userRole: userRole,
                        userId: [
                          {
                            lable: localData.userName,
                            value: localData.userId,
                          },
                        ],
                        reportMode: mode,
                        pdfWindow: mode === "pdf" ? pdfWindowRef.current : null,
                      };
                      dispatch(setTradeReportFilterValue(values));
                      dispatch(getTradeReport(values));
                    } else {
                      dispatch(setTradeReportFilterValue(value));
                      dispatch(
                        getTradeReport({
                          ...value,
                          userRole: userRole,
                          reportMode: mode,
                          pdfWindow: mode === "pdf" ? pdfWindowRef.current : null,
                        })
                      );
                    }
                    dispatch(setIsReportGet(true));
                  }}
                >
                  {({
                    getFieldProps,
                    handleChange,
                    values,
                    setFieldValue,
                    handleSubmit,
                    handleBlur,
                  }) => {
                    return (
                      <Form onSubmit={handleSubmit}>
                        <div className="row g-4">
                          <div className="col-12 col-md-6">
                            <div className="row g-4">
                              <div className="col-12 mt-3">
                                <label className="form-control-label d-block">
                                  Report Type
                                </label>
                                <div className="custom-control custom-radio custom-control-inline">
                                  <input
                                    className="custom-control-input"
                                    id="radio_11"
                                    name="reportType"
                                    type="radio"
                                    checked={values.reportType == "1"}
                                    onChange={(e) => {
                                      userRole === "User" ||
                                        userRole === "Sub Broker" ||
                                        userRole === "Partner"
                                        ? changeReportForTypeOptionValue(
                                          "1",
                                          userReportOptions
                                        )
                                        : changeReportForTypeOptionValue(
                                          "1",
                                          reportOptions
                                        );
                                      handleChange("reportType")("1");
                                    }}
                                  />
                                  <label
                                    className="custom-control-label"
                                    htmlFor="radio_11"
                                  >
                                    Position
                                  </label>
                                </div>
                                <div className="custom-control custom-radio custom-control-inline">
                                  <input
                                    className="custom-control-input"
                                    id="radio_12"
                                    name="reportType"
                                    type="radio"
                                    checked={values.reportType == "2"}
                                    onChange={(e) => {
                                      userRole === "User"
                                        ? changeReportForTypeOptionValue(
                                          "2",
                                          userReportBill
                                        )
                                        : userRole === "Sub Broker" ||
                                          userRole === "Partner"
                                          ? changeReportForTypeOptionValue(
                                            "2",
                                            subBrokerReportBill
                                          )
                                          : changeReportForTypeOptionValue(
                                            "2",
                                            reportBill
                                          );
                                      handleChange("reportType")("2");
                                    }}
                                  />
                                  <label
                                    className="custom-control-label"
                                    htmlFor="radio_12"
                                  >
                                    Billing
                                  </label>
                                </div>
                                {userRole !== "User" && (
                                  <>
                                    <div className="custom-control custom-radio custom-control-inline">
                                      <input
                                        className="custom-control-input"
                                        id="radio_13"
                                        name="reportType"
                                        type="radio"
                                        checked={values.reportType == "3"}
                                        onChange={(e) => {
                                          userRole === "Sub Broker" ||
                                            userRole === "Partner"
                                            ? changeReportForTypeOptionValue(
                                              "3",
                                              subBrokerGlobalReport
                                            )
                                            : changeReportForTypeOptionValue(
                                              "3",
                                              GlobalReport
                                            );
                                          handleChange("reportType")("3");
                                        }}
                                      />
                                      <label
                                        className="custom-control-label"
                                        htmlFor="radio_13"
                                      >
                                        Global
                                      </label>
                                    </div>
                                    {userRole !== "Sub Broker" &&
                                      userRole !== "Partner" && (
                                        <>
                                          <div className="custom-control custom-radio custom-control-inline">
                                            <input
                                              className="custom-control-input"
                                              id="radio_14"
                                              name="reportType"
                                              type="radio"
                                              checked={values.reportType == "4"}
                                              onChange={(e) => {
                                                changeReportForTypeOptionValue(
                                                  "4",
                                                  TradeReport
                                                );
                                                handleChange("reportType")("4");
                                              }}
                                            />
                                            <label
                                              className="custom-control-label"
                                              htmlFor="radio_14"
                                            >
                                              Trade
                                            </label>
                                          </div>
                                          <div className="custom-control custom-radio custom-control-inline">
                                            <input
                                              className="custom-control-input"
                                              id="radio_15"
                                              name="reportType"
                                              type="radio"
                                              checked={values.reportType == "5"}
                                              onChange={(e) => {
                                                changeReportForTypeOptionValue(
                                                  "5",
                                                  BrokerateReportOption
                                                );
                                                handleChange("reportType")("5");
                                              }}
                                            />
                                            <label
                                              className="custom-control-label"
                                              htmlFor="radio_15"
                                            >
                                              Brokerage
                                            </label>
                                          </div>
                                          <div className="custom-control custom-radio custom-control-inline">
                                            <input
                                              className="custom-control-input"
                                              id="radio_16"
                                              name="reportType"
                                              type="radio"
                                              checked={values.reportType == "6"}
                                              onChange={(e) => {
                                                changeReportForTypeOptionValue(
                                                  "6",
                                                  RMSReportOption
                                                );
                                                // setReportForTypeOption(
                                                //   RMSReportOption
                                                // );
                                                // setReportForType("6");
                                                // setIsLiveRateSource(true);
                                                handleChange("reportType")("6");
                                              }}
                                            />
                                            <label
                                              className="custom-control-label"
                                              htmlFor="radio_16"
                                            >
                                              RMS
                                            </label>
                                          </div>
                                        </>
                                      )}
                                  </>
                                )}
                              </div>
                              <div className="col-12 mt-3">
                                <label className="form-control-label">
                                  Report
                                </label>
                                <Select
                                  options={reportForTypeOption}
                                  styles={selectStyles}
                                  components={{
                                    DropdownIndicator,
                                    ClearIndicator,
                                  }}
                                  isClearable
                                  placeholder="Select Report"
                                  value={values.report}
                                  onChange={(e) => {
                                    let selectedObj = {
                                      target: {
                                        name: "report",
                                        value: e,
                                      },
                                    };
                                    handleChange("report")(selectedObj);
                                  }}
                                />
                              </div>
                              <div className="col-12 mt-3">
                                <label className="form-control-label">
                                  Valan <span className="text-danger">*</span>
                                </label>
                                <Select
                                  styles={selectStyles}
                                  components={{
                                    DropdownIndicator,
                                    ClearIndicator,
                                  }}
                                  name="valan"
                                  id="valan"
                                  placeholder="Select Valan"
                                  onBlur={() => {
                                    handleBlur({ target: { name: "valan" } });
                                  }}
                                  value={values.valan}
                                  onChange={(option) => {
                                    let selectedObj = {
                                      target: {
                                        name: "valan",
                                        value: option,
                                      },
                                    };
                                    handleChange("valan")(selectedObj);
                                    setValanSelected(option);
                                    let dataValan =
                                      valansList &&
                                      valansList.find(
                                        (item) => item.id == option.value
                                      );
                                    setFieldValue(
                                      "valanStartDate",
                                      new Date(dataValan.startDate)
                                    );
                                    setFieldValue(
                                      "valanEndDate",
                                      new Date(dataValan.endDate)
                                    );
                                  }}
                                  options={finalValanList}
                                />
                                <span className="text-error">
                                  <ErrorMessage name="valan" />
                                </span>
                              </div>
                              {userRole !== "User" && (
                                <>
                                  <div className="col-12 mt-3">
                                    <div className="custom-control custom-radio custom-control-inline">
                                      <input
                                        className="custom-control-input"
                                        id="radio_17"
                                        name="accountSettingType"
                                        type="radio"
                                        checked={
                                          values.accountSettingType == "1"
                                        }
                                        onChange={() => {
                                          handleChange("accountSettingType")(
                                            "1"
                                          );
                                          setAccountType("1");
                                          setFieldValue("userId", "");
                                        }}
                                      />
                                      <label
                                        className="custom-control-label"
                                        htmlFor="radio_17"
                                      >
                                        Customer
                                      </label>
                                    </div>
                                    {userRole !== "Sub Broker" &&
                                      userRole !== "Partner" && (
                                        <div className="custom-control custom-radio custom-control-inline">
                                          <input
                                            className="custom-control-input"
                                            id="radio_18"
                                            name="accountSettingType"
                                            type="radio"
                                            checked={
                                              values.accountSettingType == "2"
                                            }
                                            onChange={() => {
                                              setFieldValue("userId", "");
                                              handleChange(
                                                "accountSettingType"
                                              )("2");
                                              setAccountType("2");
                                            }}
                                          />
                                          <label
                                            className="custom-control-label"
                                            htmlFor="radio_18"
                                          >
                                            Authority
                                          </label>
                                        </div>
                                      )}
                                     {userRole !== "Sub Broker" &&
                                      userRole !== "Partner" && (
                                        <div className="custom-control custom-radio custom-control-inline">
                                          <input
                                            className="custom-control-input"
                                            id="radio_22"
                                            name="accountSettingType"
                                            type="radio"
                                            onChange={() => {
                                              setFieldValue("userId", "");
                                              handleChange(
                                                "accountSettingType"
                                              )("4");
                                              setAccountType("4");
                                            }}
                                          />
                                          <label
                                            className="custom-control-label"
                                            htmlFor="radio_22"
                                          >
                                          Sub Broker
                                          </label>
                                        </div>
                                      )}  
                                    <div className="custom-control custom-radio custom-control-inline">
                                      <input
                                        className="custom-control-input"
                                        id="radio_19"
                                        name="accountSettingType"
                                        type="radio"
                                        checked={
                                          values.accountSettingType == "3"
                                        }
                                        onChange={(e) => {
                                          setFieldValue("userId", "");
                                          handleChange("accountSettingType")(
                                            "3"
                                          );
                                          setAccountType("3");
                                        }}
                                      />
                                      <label
                                        className="custom-control-label"
                                        htmlFor="radio_19"
                                      >
                                        Self
                                      </label>
                                    </div>
                                  </div>
                                  <div className="col-12 mt-3">
                                    <label className="form-control-label">
                                      Customer/Authority{" "}
                                      {values.accountSettingType !== "3" && (
                                        <span className="text-danger">*</span>
                                      )}
                                    </label>
                                    <Select
                                      options={
                                        values.accountSettingType == "1"
                                          ? accountOptionList
                                          : userAuthorityList
                                      }
                                      styles={selectStyles}
                                      isDisabled={
                                        values.accountSettingType == "3"
                                      }
                                      components={{
                                        DropdownIndicator,
                                        ClearIndicator,
                                      }}
                                      name="userId"
                                      id="userId"
                                      isClearable
                                      placeholder="Select Customer"
                                      isMulti
                                      onBlur={() => {
                                        handleBlur({
                                          target: { name: "userId" },
                                        });
                                      }}
                                      value={values.userId}
                                      onChange={(option) => {
                                        let data = {
                                          target: {
                                            name: "userId",
                                            value: option,
                                          },
                                        };
                                        setSelectedUser(option);
                                        handleChange("userId")(data);
                                      }}
                                    />
                                    <span className="text-error">
                                      <ErrorMessage name="userId" />
                                    </span>
                                  </div>
                                  {!isLiveRateSource && <div className="col-12 mt-3">
                                    <label className="form-control-label d-block">
                                      Date Filter
                                    </label>
                                    <div className="custom-control custom-radio custom-control-inline">
                                      <input
                                        className="custom-control-input"
                                        id="radio_20"
                                        name="dateFilter"
                                        type="radio"
                                        checked={values.dateFilter == "All"}
                                        onChange={(e) =>
                                          handleChange("dateFilter")("All")
                                        }
                                      />
                                      <label
                                        className="custom-control-label"
                                        htmlFor="radio_20"
                                      >
                                        All Date
                                      </label>
                                    </div>
                                    <div className="custom-control custom-radio custom-control-inline">
                                      <input
                                        className="custom-control-input"
                                        id="radio_21"
                                        name="dateFilter"
                                        type="radio"
                                        checked={values.dateFilter == "Date"}
                                        onChange={(e) =>
                                          handleChange("dateFilter")("Date")
                                        }
                                      />
                                      <label
                                        className="custom-control-label"
                                        htmlFor="radio_21"
                                      >
                                        Date Wise
                                      </label>
                                    </div>
                                  </div>}
                                  {values.dateFilter == "Date" && (
                                    <div className="col-12 d-flex">
                                      <div className="custom-radio ">
                                        <div className="col-12 col-sm ">
                                          <DatePicker
                                            className="form-control"
                                            dateFormat={UI_DATEPICKER_FORMAT}
                                            maxDate={valanSelectedFirst?.startDate ? valanSelectedFirst.startDate : false}
                                            selected={values.valanStartDate}
                                            onChange={(e) => {
                                              setFieldValue(
                                                "valanStartDate",
                                                e
                                              );
                                            }}
                                          />
                                        </div>
                                      </div>
                                      <div className="custom-radio">
                                        <div className="col-12 col-sm">
                                          <DatePicker
                                            className="form-control"
                                            maxDate={valanSelectedFirst?.startDate ? valanSelectedFirst.startDate : false}
                                            dateFormat={UI_DATEPICKER_FORMAT}
                                            selected={values.valanEndDate}
                                            onChange={(e) => {
                                              setFieldValue("valanEndDate", e);
                                            }}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </>
                              )}
                            </div>
                          </div>
                          <div className="col-12 col-md-6">
                            <div className="row g-4">
                              <div className="col-12 px-0 mt-3">
                                {isLiveRateSource && (
                                  <div className="col-12">
                                    <label className="form-control-label d-block">
                                      Live Rate Source
                                    </label>
                                    {userRole !== "User" && (
                                      <div className="custom-control custom-radio custom-control-inline">
                                        <input
                                          className="custom-control-input"
                                          id="radio_23"
                                          name="radio_5"
                                          type="radio"
                                          checked={values.liveRateSource == "1"}
                                          onChange={() =>
                                            handleChange("liveRateSource")("1")
                                          }
                                        />
                                        <label
                                          className="custom-control-label"
                                          htmlFor="radio_23"
                                        >
                                          Manual
                                        </label>
                                      </div>
                                    )}
                                    <div className="custom-control custom-radio custom-control-inline">
                                      <input
                                        className="custom-control-input"
                                        id="radio_24"
                                        name="radio_5"
                                        type="radio"
                                        checked={values.liveRateSource === "2"}
                                        onChange={() =>
                                          handleChange("liveRateSource")("2")
                                        }
                                      />
                                      <label
                                        className="custom-control-label"
                                        htmlFor="radio_24"
                                      >
                                        Ltp
                                      </label>
                                    </div>
                                    <div className="custom-control custom-radio custom-control-inline">
                                      <input
                                        className="custom-control-input"
                                        id="radio_26"
                                        name="radio_5"
                                        type="radio"
                                        checked={values.liveRateSource === "3"}
                                        onChange={() =>
                                          handleChange("liveRateSource")("3")
                                        }
                                      />
                                      <label
                                        className="custom-control-label"
                                        htmlFor="radio_26"
                                      >
                                        Bhav Copy
                                      </label>
                                    </div>
                                  </div>
                                )}
                                {values.liveRateSource !== "2" && (
                                  <div className="col-12 mt-2">
                                    <DatePicker
                                      className="form-control"
                                      dateFormat={UI_DATEPICKER_FORMAT}
                                      selected={values.liverateDate}
                                      onChange={(e) => {
                                        setFieldValue("liverateDate", e);
                                      }}
                                    />
                                  </div>
                                )}
                              </div>
                              <div className="col-12 mt-3">
                                <label className="form-control-label">
                                  Segment
                                </label>
                                <Select
                                  options={segmentsList}
                                  styles={selectStyles}
                                  components={{
                                    DropdownIndicator,
                                    ClearIndicator,
                                  }}
                                  isClearable
                                  name="segment"
                                  id="segment"
                                  value={values.segment}
                                  placeholder="Select Segment"
                                  onBlur={() => {
                                    handleBlur({ target: { name: "segment" } });
                                  }}
                                  onChange={(option) => {
                                    let e = {
                                      target: {
                                        name: "segment",
                                        value: option,
                                      },
                                    };
                                    handleChange("segment")(e);
                                    option &&
                                      dispatch(
                                        getSymbolList({
                                          id: option && option.value,
                                        })
                                      );
                                    dispatch(setSymbolList([]));
                                  }}
                                />
                                <span className="text-error">
                                  <ErrorMessage name="segment" />
                                </span>
                              </div>

                              <div className="col-12 mt-3">
                                <label className="form-control-label">
                                  Symbol
                                </label>
                                <Select
                                  options={symbolList}
                                  styles={selectStyles}
                                  components={{
                                    DropdownIndicator,
                                    ClearIndicator,
                                  }}
                                  value={values.symbol}
                                  isClearable
                                  placeholder="Select Symbol"
                                  onBlur={() => {
                                    handleBlur({ target: { name: "symbol" } });
                                  }}
                                  onChange={(optionObject) => {
                                    let data = {
                                      target: {
                                        name: "symbol",
                                        value: optionObject,
                                      },
                                    };
                                    handleChange("symbol")(data);
                                  }}
                                />
                              </div>
                              {/* <div className="col-12">
															<label className="form-control-label">
																Sub Broker
															</label>
															<Select
																options={agentORSubBrokerList}
																styles={selectStyles}
																components={{
																	DropdownIndicator,
																	ClearIndicator,
																}}
																isClearable
																placeholder="Select Sub Broker"
																onBlur={() => {
																	handleBlur({ target: { name: "subBroker" } });
																}}
																onChange={(option) => {
																	let e = {
																		target: {
																			name: "subBroker",
																			value: option,
																		},
																	};
																	setFieldValue("accountSettingType", "1");
																	handleChange("subBroker")(e);
																}}
															/>
														</div> */}
                              {userRole !== "User" && (
                                <>
                                  <div className="col-12 mt-3">
                                    <div className="row g-2">
                                      <div className="col-12 col-sm-auto">
                                        <div className="custom-control custom-checkbox">
                                          <input
                                            className="custom-control-input"
                                            id="checbox_25"
                                            type="checkbox"
                                            {...getFieldProps("isExpiryDate")}
                                          />

                                          <label
                                            className="custom-control-label"
                                            htmlFor="checbox_25"
                                          >
                                            Expiry Date
                                          </label>
                                        </div>
                                      </div>
                                      {values.isExpiryDate && (
                                        <div className="col-12 col-sm">
                                          <DatePicker
                                            className="form-control"
                                            dateFormat={UI_DATEPICKER_FORMAT}
                                            selected={values.expiryDate}
                                            onChange={(e) => {
                                              setFieldValue("expiryDate", e);
                                            }}
                                          />
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                  <div className="col-12 mt-3">
                                    <label className="form-control-label">
                                      Order By{" "}
                                      <span className="text-danger">*</span>
                                    </label>
                                    <Select
                                      styles={selectStyles}
                                      components={{
                                        DropdownIndicator,
                                        ClearIndicator,
                                      }}
                                      name="orderBy"
                                      onBlur={() => {
                                        handleBlur({
                                          target: { name: "orderBy" },
                                        });
                                      }}
                                      id="orderBy"
                                      placeholder="Client Code"
                                      value={values.orderBy}
                                      onChange={(option) => {
                                        let selectedObj = {
                                          target: {
                                            name: "orderBy",
                                            value: option,
                                          },
                                        };
                                        handleChange("orderBy")(selectedObj);
                                      }}
                                      options={orderByOption}
                                    />
                                    <span className="text-error">
                                      <ErrorMessage name="orderBy" />
                                    </span>
                                  </div>
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      </Form>
                    );
                  }}
                </Formik>
              </CardBody>
            </Card>
          </div>
        </div>
      </Container>
      {tradeReportLoading && (
        <div className="spinner-box">
          <Spinner className="ml-2" color="primary" />
        </div>
      )}
    </div>
  );
}

export default ReportTrade;
